module.exports = __webpack_public_path__ + "static/NataljaFakirova-e428e131960a2cc87acd011a5ca50331.jpg";